import React from 'react';
import { connect } from 'react-redux';

import { startCTAFlow } from 'actions/editor';
import { LOOM_PRO } from 'constants/capabilities';
import {
  ADD_CUSTOM_VIDEO_CTA_CLICKED,
  SHARE_PAGE_EDITOR_FAB_PRO_UPSELL,
} from 'constants/events';
import { HELP_ADD_CTA } from 'constants/feature-tour';
import * as analytics from 'utilities/analytics';
import { isMobile } from 'utilities/device';

import { selectUserCanEditVideo } from 'selectors/shareVideo';

import ActionDot, { TOP_LEFT } from 'components/ui-components/action-dot';
import FabButton from 'components/ui-components/fab-button';

import './styles.less';

class AddVideoCtaButton extends React.Component {
  state = {
    hovering: false,
  };

  render() {
    const { ctaEnabled, disabled, hasPro, userCanEditVideo } = this.props;
    const { hovering } = this.state;

    // Show if url arg is there or if the user has already enabled it
    let button = null;

    if (hasPro) {
      button = (
        <FabButton
          disabled={disabled}
          icon="cta-wh"
          renderButtonChildren={this.renderActionDot}
          onClick={this.handleClick}
        >
          {ctaEnabled ? (
            'Edit CTA'
          ) : (
            <span>
              Call-to-
              <br />
              action
            </span>
          )}
        </FabButton>
      );
    } else {
      button = (
        <FabButton
          disabled={!hovering}
          onHover={this.startHovering}
          onBlur={this.endHovering}
          renderButtonChildren={this.renderActionDot}
          icon="cta-wh"
          onClick={this.handleUpgradeUpsell}
        >
          {!hovering && (
            <span>
              Call-to-
              <br />
              action
            </span>
          )}
          {hovering && (
            <span className="fab-button-upgrade-label">
              Upgrade
              <br />
              to Pro
            </span>
          )}
        </FabButton>
      );
    }

    return userCanEditVideo && !isMobile && button;
  }

  handleUpgradeUpsell = () => {
    analytics.track(SHARE_PAGE_EDITOR_FAB_PRO_UPSELL, {
      fab_type: 'cta',
    });
    this.props.showUpgradeModal();
  };

  startHovering = () => this.setState({ hovering: true });
  endHovering = () => this.setState({ hovering: false });

  renderActionDot = () => {
    if (this.props.ctaTourIsActive) {
      return <ActionDot position={TOP_LEFT} />;
    }

    return null;
  };

  handleClick = () => {
    analytics.track(ADD_CUSTOM_VIDEO_CTA_CLICKED);

    this.props.startCTAFlow(!this.props.showCtaModal);
  };
}

const mapStateToProps = state => {
  const {
    cta_modal_show: showCtaModal,
    cta_enabled: ctaEnabled,
  } = state.share_video;

  const { current: user } = state.user;

  const { currentTour, tourOpenAndActive } = state.featureTour;

  const ctaTourIsActive = currentTour === HELP_ADD_CTA && tourOpenAndActive;

  return {
    showCtaModal,
    ctaEnabled,
    ctaTourIsActive,
    hasPro: user && user.capabilities[LOOM_PRO],
    userCanEditVideo: selectUserCanEditVideo(state),
  };
};

const mapDispatchToProps = dispatch => ({
  startCTAFlow: () => dispatch(startCTAFlow()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddVideoCtaButton);
